import script from "./IndexadorPDFs.vue?vue&type=script&setup=true&lang=js"
export * from "./IndexadorPDFs.vue?vue&type=script&setup=true&lang=js"

import "./IndexadorPDFs.vue?vue&type=style&index=0&id=2d476130&scoped=true&lang=css"

import exportComponent from "C:\\Software\\Aplicaciones\\allikamay\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2d476130"]])

export default __exports__